import axios from 'axios';
import type {
  PPUserStatusResponse,
  PPUserStatusResponseDto,
  PPLoginStatusResponse,
  EngageAccountAdminDto,
  EngageAccountAdmin,
} from './types';
import { engageAccountAdminDtoToModel, ppUserStatusDtoToModel } from './mapper';

export const getEngageUserStatus = (orgId: number): Promise<PPUserStatusResponse> => {
  return axios
    .get<PPUserStatusResponseDto>('/engage/api/users/check_org_and_user/', {
      params: { org_id: orgId },
    })
    .then((response) => ppUserStatusDtoToModel(response.data));
};

export const acceptUserTC = (): Promise<void> => {
  return axios.post('/api/v1/engage/tac/accept');
};

export const getEngageLoginStatus = (
  orgId: number,
  siteId: number,
): Promise<PPLoginStatusResponse> => {
  return axios
    .post<PPLoginStatusResponse>('/engage/api/users/login_from_insights/', {
      org_id: orgId,
      site_id: siteId,
    })
    .then((response) => response.data);
};

export const getEngageAccountAdmin = (accountId: number): Promise<EngageAccountAdmin> => {
  return axios
    .get<EngageAccountAdminDto>(`/api/v1/engage/account/${accountId}/account-admin`)
    .then((response) => engageAccountAdminDtoToModel(response.data));
};
